import { useSetAgeDays } from './UseSetAgeDays';
import { useSetBrands } from './UseSetBrands';
import { useSetExtColor } from './UseSetExtColor';
import { useSetIntColor } from './UseSetIntColor';
import { useSetInventoryData } from './UseSetInventoryData';
import { useSetMileage } from './UseSetMileage';
import { useSetModels } from './UseSetModels';
import { useSetPrice } from './UseSetPrice';
import { useSetTrims } from './UseSetTrims';
import { useSetYears } from './UseSetYears';

export const useSetInitialValues = () => {
  useSetInventoryData();
  useSetYears();
  useSetModels();
  useSetTrims();
  useSetBrands();
  useSetExtColor();
  useSetIntColor();
  useSetPrice();
  useSetMileage();
  useSetAgeDays();
};
